




























import { EventBus } from '@/main/eventBus';

import { DmsBaseComponent } from '#components/dms/common/base';

import { PageMode } from '../../../utils/pageMode';


export default DmsBaseComponent.extend({
	name: 'DmsDialog',
	props: {
		dialogMode: { type: String, validator: (item) => (Object.values(PageMode) as string[]).includes(item) },
		top: String,
		visible: { type: Boolean, required: true },
		hideOk: Boolean,
		fullHeight: Boolean,
		hideCancel: Boolean,
		hideButtons: Boolean,
		disableOk: { type: Boolean, default: false },
		model: { type: Object, default: Object },
		rules: { type: Object, default: Object },
		closeOnClickModal: { type: Boolean, default: true },
		closeOnPressEscape: { type: Boolean, default: true },
		pdf: { type: Boolean, default: true },
		fullscreen: { type: Boolean, default: false },
		width: { type: String, default: '50%' },
		beforeClose: { type: Function, default: (done: () => void) => { done(); }, required: false },
		isRightAlignOkButton: { type: Boolean, default: false },
	},
	computed: {
		topCmp(): string {
			return this.fullHeight ? '5vh' : this.top;
		},
		isTitleSlotEmpty(): Boolean {
			return !this.$slots.title;
		},
		visibleCmp: {
			get(): boolean {
				return this.visible;
			},
			set(val: boolean) {
				this.$emit('update:visible', val);
			},
		},
	},
	updated() {
		EventBus.$emit('Mode', this.dialogMode);
	},
});
